import * as React from 'react';

import * as PermissionsHelper from '../../helpers/permissionsHelper';
import { PageTitle } from '../pages/pageTitle';

import NewShopForm from './newShopForm';
import ShopsTable from './shopsTable';

// eslint-disable-next-line react/prefer-stateless-function
export class ShopsPage extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="Shops">
          {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessShops) && <NewShopForm />}
        </PageTitle>
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessShops) && <ShopsTable />}
      </>
    );
  }
}
